import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountsRoutingModule } from './accounts-routing.module';
import { TermsAndConditionsComponent } from './sign-up/terms-and-conditions/terms-and-conditions.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../services/snackbar.service';
import { LogOutComponent } from './log-out/log-out.component';
import { CookieService } from 'ngx-cookie-service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LoginSelectionComponent } from './login-selection/login-selection.component';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { CommonSectionModule } from '../common-section/common-section.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LoginComponent,
    SignUpComponent,
    TermsAndConditionsComponent,
    ForgotPasswordComponent,
    NewPasswordComponent,
    LogOutComponent,
    ChangePasswordComponent,
    LoginSelectionComponent
  ],
  imports: [
    CommonModule,
    AccountsRoutingModule,
    CommonSectionModule,
    MatSnackBarModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [CookieService]
 
})
export class AccountsModule { }
